// extracted by mini-css-extract-plugin
export var heading = "related-module--heading--1b0b7";
export var item = "related-module--item--e8a5f";
export var items = "related-module--items--337bf";
export var root = "related-module--root--da14b";